import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { scrollToSection } from '../utils/navigation';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
}

const VideoModal: React.FC<VideoModalProps> = ({ isOpen, onClose, title, description }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex justify-between items-center p-6 border-b">
          <h3 className="text-2xl font-bold text-gray-900">{title}</h3>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="p-6">
          <div className="aspect-video bg-gradient-to-br from-red-600 to-red-800 rounded-lg flex items-center justify-center mb-4">
            <div className="text-center text-white">
              <Play className="h-16 w-16 mx-auto mb-4 opacity-80" />
              <h4 className="text-xl font-semibold mb-2">Vidéo de Formation</h4>
              <p className="text-red-100">Contenu vidéo disponible pour les élèves inscrits</p>
            </div>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-900">Description du module</h4>
            <p className="text-gray-600">{description}</p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p className="text-yellow-800">
                <strong>Note :</strong> Les vidéos complètes sont accessibles aux élèves inscrits à la formation. 
                Contactez-nous pour plus d'informations sur l'accès aux contenus pédagogiques.
              </p>
            </div>
            
            <div className="flex gap-4">
              <button 
                onClick={() => {
                  onClose();
                  setTimeout(() => scrollToSection('inscription'), 100);
                }}
                className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-semibold"
              >
                S'inscrire à la Formation
              </button>
              <button 
                onClick={() => {
                  onClose();
                  setTimeout(() => scrollToSection('contact'), 100);
                }}
                className="border border-red-600 text-red-600 px-6 py-3 rounded-lg hover:bg-red-50 transition-colors font-semibold"
              >
                Nous Contacter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;